export default __webpack_public_path__ + "static/media/login.b784ae17.svg";